import { render, staticRenderFns } from "./EProtocoloFiltros.vue?vue&type=template&id=395136a4&scoped=true&"
import script from "./EProtocoloFiltros.vue?vue&type=script&lang=js&"
export * from "./EProtocoloFiltros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395136a4",
  null
  
)

export default component.exports